import Vue from 'vue'

import 'normalize.css/normalize.css'





import './utils/vconsole'






import '@/styles/index.scss' 

import App from './App'
import router from './router'
import store from './store'

import '@/icons' 
import '@/permission' 


import Vant from 'vant';
import 'vant/lib/index.css';
import {getJsSdkConfig} from "./api/order";

Vue.use(Vant);

Vue.config.productionTip = false



















let vue = new Vue({
el: '#app',
router,
store,
template: '<App/>',
components: {App}
})

export default vue



// WEBPACK FOOTER //
// ./src/main.js